import { Injectable } from "@angular/core";
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PwaService {
  // For installing pwa application locally
  promptEvent: any;
  private deferredPrompt: any;
  showInstallPrompt$ = new BehaviorSubject<boolean>(false);
  constructor(private swUpdate: SwUpdate) {
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault();
      this.promptEvent = event;
      this.deferredPrompt = event;
      this.showInstallPrompt$.next(true);
    });
  }

  setupPWAInstall() {
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      this.deferredPrompt = event;
      this.showInstallPrompt$.next(true); 
    });
  }

  installPWA() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('PWA installed');
        }
        this.deferredPrompt = null;
        this.showInstallPrompt$.next(false); 
      });
    }
  }

  // checkForUpdates() {
  //   if (this.swUpdate.isEnabled) {
  //     this.swUpdate.versionUpdates
  //       .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
  //       .subscribe(() => {
  //         if (confirm('A new version is available. Load new version?')) {
  //           window.location.reload();
  //         }
  //       });
  //   }
  // }

}
